import { Button, Card, Col, Row, Stack } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SmallModalTemplate from 'src/components/SmallModalTemplate';

import { DeviceDataView } from 'src/models/GalenData/DeviceDataView.model';
import { OrderData } from 'src/models/GalenData/Order.model';
import { I18NextNS } from 'src/models/Language.model';
export type CancelOrderConfirmationModalProps = {
  show: boolean;
  order?: DeviceDataView<OrderData>;
  isCancelling: boolean;
  onGoBack: () => void;
  onConfirm: () => void;
};

export default function CancelOrderConfirmationModal({
  show,
  order,
  isCancelling,
  onGoBack,
  onConfirm,
}: CancelOrderConfirmationModalProps) {
  const { t } = useTranslation(I18NextNS.COMMON);

  return (
    <SmallModalTemplate
      show={show}
      onHide={onGoBack}
      iconWrapperClassName="bg-danger-100"
      icon={
        <FontAwesomeIcon
          icon={faCircleXmark}
          className="text-danger"
          size="sm"
        />
      }
      title={t('orderDetails.cancelOrderTitle')}
      description={t('orderDetails.cancelOrderDescription')}
      card={
        <Card className="bg-light border-0">
          <Card.Body>
            <Stack gap={2}>
              <Row>
                <Col xs={5} className="fw-medium">
                  {t('orderDetails.dateOfBirth')}
                </Col>
                <Col>{order?.owner?.dateOfBirth}</Col>
              </Row>
              <Row>
                <Col xs={5} className="fw-medium">
                  {t('orderDetails.firstName')}
                </Col>
                <Col>{order?.owner?.firstName}</Col>
              </Row>
              <Row>
                <Col xs={5} className="fw-medium">
                  {t('orderDetails.lastName')}
                </Col>
                <Col>{order?.owner?.lastName}</Col>
              </Row>
              <Row>
                <Col xs={5} className="fw-medium">
                  {t('orderDetails.patientId')}
                </Col>
                <Col>{order?.owner?.patientId}</Col>
              </Row>
              <Row>
                <Col xs={5} className="fw-medium">
                  {t('orderDetails.site')}
                </Col>
                <Col>{order?.data?.SiteName?.value}</Col>
              </Row>
            </Stack>
          </Card.Body>
        </Card>
      }
      leftButton={
        <Button
          variant="outline-primary"
          onClick={onGoBack}
          disabled={isCancelling}
          data-test="cancel-order-go-back"
          data-track="exam.cancel-order-modal.go-back"
          data-observe
        >
          {t('orderDetails.cancelOrderGoBack')}
        </Button>
      }
      rightButton={
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={isCancelling}
          data-test="cancel-order-confirm"
          data-track="exam.cancel-order-modal.confirm"
          data-observe
        >
          {isCancelling
            ? t('orderDetails.cancellingOrder')
            : t('orderDetails.cancelOrderTitle')}
        </Button>
      }
    />
  );
}
